import React from 'react';
export function ProductBenefits() {
  const scientificProof = [{
    icon: '🔬',
    stat: '+20,2% MUSKELDICKE',
    description: 'in 12 Wochen – Identisch zu Whey-Protein, aber 100% vegan und besser verträglich',
    source: 'Journal of the International Society of Sports Nutrition'
  }, {
    icon: '🔬',
    stat: '94% BIOVERFÜGBARKEIT',
    description: 'Höchste Aufnahmerate unter allen pflanzlichen Proteinen',
    source: 'National Center for Biotechnology Information'
  }, {
    icon: '🔬',
    stat: '+40% MEHR SÄTTIGUNG',
    description: 'Weniger Hunger, weniger Kalorien, mehr Erfolg beim Abnehmen',
    source: 'British Journal of Nutrition'
  }, {
    icon: '🔬',
    stat: '+36% GESUNDE DARMBAKTERIEN',
    description: 'Bessere Verdauung, kein Völlegefühl, keine Blähungen',
    source: 'Gut Microbes Journal'
  }];
  const proteins = [{
    number: '1️⃣',
    name: 'BIO ERBSENPROTEIN (61%)',
    benefits: ['+20,2% Muskelaufbau in 12 Wochen', '94% Verdaulichkeit – perfekt für sensible Mägen', 'Identische Wirkung wie Whey-Protein']
  }, {
    number: '2️⃣',
    name: 'BIO REISPROTEIN (14%)',
    benefits: ['+7,5% mehr Muskelmasse in 8 Wochen', '-13,8% weniger Entzündungen', '-1,8kg Körperfett im Durchschnitt']
  }, {
    number: '3️⃣',
    name: 'KÜRBISKERN, LUPINEN & SONNENBLUME',
    benefits: ['+40% mehr Sättigung', '-32% LDL-Cholesterin', 'Perfekt für Herz-Kreislauf-Gesundheit']
  }, {
    number: '4️⃣',
    name: 'TAURIN (Power-Booster)',
    benefits: ['-21% weniger Muskelermüdung', '+30% schnellere Regeneration', '+17% mehr Knochenmasse']
  }, {
    number: '5️⃣',
    name: 'PRÄBIOTISCHE BALLASTSTOFFE',
    benefits: ['+36% gesunde Darmbakterien', '+22% bessere Verdauung', 'Null Blähungen']
  }];
  return <section className="py-16 bg-white" data-id="element-213">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-214">
        <div className="text-center mb-12" data-id="element-215">
          <span className="inline-block bg-emerald-100 text-emerald-700 text-sm font-medium py-1 px-3 rounded-full mb-3" data-id="element-216">
            Wissenschaftlich bewiesen
          </span>
          <h3 className="text-4xl font-bold text-gray-800 mb-4" data-id="element-217">
            37 klinische Studien beweisen: eve Vanilla Protein wirkt
          </h3>
          <p className="text-gray-600" data-id="element-218">
            Während andere Hersteller leere Versprechen machen, haben wir die
            Fakten
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-219">
          {scientificProof.map((proof, index) => <div key={index} className="bg-emerald-50 p-6 rounded-xl border-2 border-emerald-200" data-id="element-220">
              <div className="text-4xl mb-4" data-id="element-221">{proof.icon}</div>
              <h4 className="text-2xl font-bold text-emerald-700 mb-3" data-id="element-222">
                {proof.stat}
              </h4>
              <p className="text-gray-700 mb-3 font-medium" data-id="element-223">
                {proof.description}
              </p>
              <p className="text-sm text-gray-600 italic" data-id="element-224">
                Quelle: {proof.source}
              </p>
            </div>)}
        </div>
        <div className="mb-12" data-id="element-225">
          <h3 className="text-3xl font-bold text-gray-800 mb-8 text-center" data-id="element-226">
            Die 5 Super-Proteine, die alles verändern
          </h3>
          <div className="space-y-6" data-id="element-227">
            {proteins.map((protein, index) => <div key={index} className="bg-gray-50 p-6 rounded-xl border border-gray-200" data-id="element-228">
                <div className="flex items-center mb-4" data-id="element-229">
                  <span className="text-3xl mr-4" data-id="element-230">{protein.number}</span>
                  <h4 className="text-xl font-bold text-gray-800" data-id="element-231">
                    {protein.name}
                  </h4>
                </div>
                <div className="pl-16 space-y-2" data-id="element-232">
                  {protein.benefits.map((benefit, idx) => <p key={idx} className="text-gray-700" data-id="element-233">
                      ➜ {benefit}
                    </p>)}
                </div>
              </div>)}
          </div>
          <div className="mt-8 bg-emerald-50 p-6 rounded-xl border border-emerald-200" data-id="element-234">
            <p className="text-gray-700 font-semibold text-center" data-id="element-235">
              PLUS: Volle Dosis an B-Vitaminen, Zink, Cholin, Brokkoli &
              Spinat-Extrakt
            </p>
          </div>
        </div>
      </div>
    </section>;
}